import { content } from '@content';
import { OptionItem } from '@components';
/**
 * ContentCenterFilters component constants
 */

export enum OptionsTypes {
  LAST_USED = 'lastUsed',
  FILTER_BY = 'filterBy',
  SORT_BY = 'sortBy',
  DIVIDER = 'divider',
}

export enum FilterByValues {
  NONE = 'none',
  ONLY_RECENT = 'lastUsed', // 'lastUsed' maps to 'onlyRecent' filter
  NOT_IN_USE = 'notInUse',
}

export enum SortValues {
  LAST_USED = 'lastUsed',
  AUTHOR = 'author',
  CREATED = 'createdAt',
  UPDATED = 'updatedAt',
}

export const INITIAL_OPTIONS: OptionItem[] = [
  {
    id: '1',
    label: content.filterBy,
    subOptions: [
      {
        id: '2',
        type: OptionsTypes.FILTER_BY,
        label: content.none,
        value: FilterByValues.NONE,
        active: true,
      },
      {
        id: '3',
        type: OptionsTypes.FILTER_BY,
        label: content.onlyRecent,
        value: FilterByValues.ONLY_RECENT,
      },
      {
        id: '4',
        type: OptionsTypes.FILTER_BY,
        label: content.notInUse,
        value: FilterByValues.NOT_IN_USE,
      },
    ],
  },
  {
    id: '5',
    type: OptionsTypes.DIVIDER,
  },
  {
    id: '6',
    label: content.sortBy,
    subOptions: [
      {
        id: '7',
        type: OptionsTypes.SORT_BY,
        label: content.createdDate,
        value: SortValues.CREATED,
        active: true,
      },
      {
        id: '8',
        type: OptionsTypes.SORT_BY,
        label: content.editedDate,
        value: SortValues.UPDATED,
      },
      {
        id: '9',
        type: OptionsTypes.SORT_BY,
        label: content.lastDeployment,
        value: SortValues.LAST_USED,
      },
      {
        id: '10',
        type: OptionsTypes.SORT_BY,
        label: content.author,
        value: SortValues.AUTHOR,
      },
    ],
  },
];

export const ITEMS_PER_PAGE_FOR_SUGGESTIONS = 20; // 1000;

export const SUGGESTIONS_SEARCH_DEBOUNCE_DELAY_MS = 500;
